export var KEY = '---------';
export default function separatorItem() {
  return {
    name: KEY
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/es/plugins/contextMenu/predefinedItems/separator.js
// module id = null
// module chunks = 